import React from 'react';
import logo from '../assets/logo-optimized.webp';
import { useLanguage } from '../i18n';
import LanguageSwitcher from './LanguageSwitcher';

const Navigation: React.FC = () => {
    const { t, isRTL } = useLanguage();
    
    const scrollToSection = (id: string) => {
        const element = document.getElementById(id);
        element?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <nav style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: 'rgba(10, 10, 26, 0.95)',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 2px 20px rgba(0,0,0,0.3)',
            zIndex: 1000,
            padding: '1rem 2rem',
            direction: isRTL ? 'rtl' : 'ltr'
        }}>
            <div style={{
                maxWidth: '1400px',
                margin: '0 auto',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <div style={{
                    fontSize: '1.5rem',
                    fontWeight: 'bold',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem'
                }}>
                    <img 
                        src={logo} 
                        alt="Orbit AI" 
                        style={{
                            height: '50px',
                            width: 'auto'
                        }}
                    />
                </div>
                <div style={{
                    display: 'flex',
                    gap: '2rem',
                    alignItems: 'center'
                }}>
                    <button onClick={() => scrollToSection('products')} style={{
                        cursor: 'pointer',
                        color: 'rgba(255,255,255,0.8)',
                        background: 'none',
                        border: 'none',
                        fontSize: '1rem',
                        fontWeight: '500',
                        transition: 'color 0.3s',
                        fontFamily: isRTL ? 'Tajawal, sans-serif' : 'inherit'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.color = '#a5b4fc'}
                    onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.8)'}
                    >{t.nav.products}</button>
                    <button onClick={() => scrollToSection('governance-engine')} style={{
                        cursor: 'pointer',
                        color: 'rgba(255,255,255,0.8)',
                        background: 'none',
                        border: 'none',
                        fontSize: '1rem',
                        fontWeight: '500',
                        transition: 'color 0.3s',
                        fontFamily: isRTL ? 'Tajawal, sans-serif' : 'inherit'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.color = '#a5b4fc'}
                    onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.8)'}
                    >{t.nav.governance}</button>
                    <button onClick={() => scrollToSection('chrome-extension')} style={{
                        cursor: 'pointer',
                        color: 'rgba(255,255,255,0.8)',
                        background: 'none',
                        border: 'none',
                        fontSize: '1rem',
                        fontWeight: '500',
                        transition: 'color 0.3s',
                        fontFamily: isRTL ? 'Tajawal, sans-serif' : 'inherit'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.color = '#a5b4fc'}
                    onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.8)'}
                    >{t.nav.extension}</button>
                    
                    <LanguageSwitcher />
                    
                    <button onClick={() => scrollToSection('chrome-extension')} style={{
                        backgroundColor: '#6366f1',
                        color: 'white',
                        border: 'none',
                        padding: '0.75rem 1.5rem',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        transition: 'all 0.3s',
                        boxShadow: '0 2px 8px rgba(99, 102, 241, 0.3)',
                        fontFamily: isRTL ? 'Tajawal, sans-serif' : 'inherit'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#4f46e5';
                        e.currentTarget.style.transform = 'scale(1.05)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#6366f1';
                        e.currentTarget.style.transform = 'scale(1)';
                    }}
                    >
                        {t.hero.btnInstall}
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navigation;
